//Stores
import InventoryStatusStore from "@shared/svelte/Stores/InventoryStatusStore";

import type { InventoryStatus } from "@shared/types/InventoryStatus";

export const setInventoryStatusesInStore = (inventoryStatuses?: {
  [id: number]: InventoryStatus[];
}) => {
  if (!inventoryStatuses) {
    return;
  }
  InventoryStatusStore.update(n => {
    n["loadingInventoryStatuses"] = false;
    Object.assign(n["inventoryStatuses"], inventoryStatuses);
    n["numberOfSkusInStock"] = calculateNumberOfSkusInStock(inventoryStatuses);
    return n;
  });
};

const calculateNumberOfSkusInStock = (inventoryStatuses: { [id: number]: InventoryStatus[] }) => {
  let numberOfSkusInStock = {};
  Object.keys(inventoryStatuses).forEach(function (key, index) {
    numberOfSkusInStock[key] =
      inventoryStatuses[key]?.filter(status => status.verified_in_stock)?.length || 0;
  });
  return numberOfSkusInStock;
};
